import { useAccountInfoContext } from '../../../services/account-data-service';
import { BodyText } from '@block-explorer/ui';
import { FlexRow } from '@make-software/cspr-design';
import { AccountInfoIcon } from '../../account-info-icon/account-info-icon';
import React from 'react';
import { AccountInfoResult, Deploy } from '@block-explorer/entities';
import { buildRouterPath } from '../../../router/utils';
import { ACCOUNT_DETAILS_PATH } from '../../../router/paths';
import { deriveAccountInfo, isValidPublicKey } from '../../../utils/account';
import { isWASMProxyTransaction } from '../../../utils/contract.tsx';
import { WasmProxyBadge } from '../wasm-proxy-badge.tsx';

export const TransferActionMessage = ({
  deploy,
  showOnlyActionName = false,
}: {
  deploy: Deploy;
  showOnlyActionName?: boolean;
}) => {
  const { getAccountInfo, getPublicKeyAccountHash, getPublicKeyByURef } =
    useAccountInfoContext();

  const recipientKey = deploy.args.target?.parsed as string;
  const isRecipientKeyValidPublicKey =
    recipientKey && isValidPublicKey(recipientKey);

  const recipientPublicKey = isRecipientKeyValidPublicKey
    ? recipientKey
    : getPublicKeyAccountHash(recipientKey) || getPublicKeyByURef(recipientKey);

  const recipientInfo = getAccountInfo<AccountInfoResult>(
    recipientPublicKey || ''
  );

  const recipientLogo =
    recipientInfo &&
    deriveAccountInfo(
      recipientInfo.account_info || recipientInfo.centralized_account_info
    )?.logo;
  const recipientCsprName = recipientInfo?.cspr_name;

  const recipientAccountPath =
    recipientPublicKey || recipientKey
      ? buildRouterPath(
          ACCOUNT_DETAILS_PATH,
          { id: recipientPublicKey || recipientKey },
          undefined
        )
      : '';

  return (
    <FlexRow align={'baseline'} itemsSpacing={4}>
      {isWASMProxyTransaction(deploy.executionTypeId) && <WasmProxyBadge />}
      <BodyText monotype size={3}>
        Transfer
      </BodyText>
      {!showOnlyActionName && (recipientPublicKey || recipientKey) ? (
        <FlexRow itemsSpacing={6} align={'center'}>
          <BodyText size={3} variation={'darkGray'}>
            to{' '}
          </BodyText>{' '}
          <AccountInfoIcon
            publicKey={recipientPublicKey || recipientKey}
            csprName={recipientCsprName}
            logo={recipientLogo || null}
            path={recipientAccountPath}
          />{' '}
        </FlexRow>
      ) : null}
    </FlexRow>
  );
};
